import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=aa0d84e2&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=aa0d84e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0d84e2",
  null
  
)

export default component.exports